export default {
  // 對話框標題
  dialogTitle: "同時段同IP時間配置",

  // 時間範圍說明
  timeRangeDescription:
    "時間範圍說明：[1天內]自然日，[3天內] 往前3天和往後3天，[1週內] 取年月日往前7天和往後7天，[1月內] 取年月日往前30天和往後30天，[3月內] 取年月日往前90天和往後90天，[半年內]取年月日往前180天和往後180天，[不限] 顯示所有的同IP用戶。",

  // 時間選項
  oneDay: "1天內",
  threeDays: "3天內",
  oneWeek: "1週內",
  oneMonth: "1月內",
  threeMonths: "3月內",
  halfYear: "半年內",
  noLimit: "不限",

  // 按鈕
  cancel: "取消",
  confirm: "確認",

  // 消息提示
  configSuccess: "配置成功",
};
